import { exists } from '@/helpers/utilities';

export let mixin = ({ node = null, config = {} } = {}) => {
if (!node) return false;

let state = {
	node,
	config,
	toastMessage: config.message || 'Link Copied',
	toastDuration: config.duration || 3000,
};

let module = {
	/**
	* Create and show a non-blocking toast notification
	*/
	showToast(message) {
	// 1. Remove existing toasts to prevent stacking
	const existingToast = document.querySelector('.toast-alert');
	if (existingToast) existingToast.remove();

	const toast = document.createElement('div');
	toast.classList.add('toast-alert', 'd-flex', 'align-items-center', 'py-2', 'px-3');

	// 2. Define the SVG icon separately
	const svgIcon = `
		<svg xmlns="http://www.w3.org" viewBox="0 0 640 640" style="height: 1.2em; width: auto;" fill="currentColor">
		<path d="M451.5 160c-16.6 0-32.7 4.5-46.8 12.7-15.8-16-34.2-29.4-54.5-39.5 28.2-24 64.1-37.2 101.3-37.2C537.9 96 608 166 608 252.5c0 41.5-16.5 81.3-45.8 110.6l-71.1 71.1C461.8 463.5 422 480 380.5 480 294.1 480 224 410 224 323.5c0-1.5 0-3 .1-4.5.5-17.7 15.2-31.6 32.9-31.1s31.6 15.2 31.1 32.9v2.6c0 51.1 41.4 92.5 92.5 92.5 24.5 0 48-9.7 65.4-27.1l71.1-71.1c17.3-17.3 27.1-40.9 27.1-65.4 0-51.1-41.4-92.5-92.5-92.5zm-144.3 77.3c-1.9-.8-3.8-1.9-5.5-3.1-12.6-6.5-27-10.2-42.1-10.2-24.5 0-48 9.7-65.4 27.1l-71.1 71.1C105.8 339.5 96 363.1 96 387.6c0 51.1 41.4 92.5 92.5 92.5 16.5 0 32.6-4.4 46.7-12.6 15.8 16 34.2 29.4 54.6 39.5-28.2 23.9-64 37.2-101.3 37.2-86.4 0-156.5-70-156.5-156.5 0-41.5 16.5-81.3 45.8-110.6l71.1-71.1c29.3-29.3 69.1-45.8 110.6-45.8 86.6 0 156.5 70.6 156.5 156.9v3.9c-.4 17.7-15.1 31.6-32.8 31.2s-31.6-15.1-31.2-32.8v-2.3c0-33.7-18-63.3-44.8-79.6z"/>
		</svg>`;

	// Assemble: SVG + Text inside a span
	toast.innerHTML = svgIcon + `<span>${message}</span>`;
	
	document.body.appendChild(toast);

	// Fade in
	setTimeout(() => {
		toast.style.opacity = '1';
		toast.classList.add('shown');
	}, 10);

	// Fade out and remove after duration
	setTimeout(() => {
		toast.style.opacity = '0';
		toast.classList.remove('shown');
		setTimeout(() => {
		if (document.body.contains(toast)) toast.remove();
		}, 300);
	}, state.toastDuration);
	},

	handleCopy() {
	const textToCopy = state.node.getAttribute('data-copy') || state.node.innerText;
	if (!textToCopy) return;

	navigator.clipboard.writeText(textToCopy).then(() => {
		state.node.classList.add('is-copied');
		
		// Trigger the toast
		this.showToast(state.toastMessage);

		setTimeout(() => {
		if (exists(state.node)) state.node.classList.remove('is-copied');
		}, 2000);
	}).catch(err => {
		console.error('ClickToCopy: Could not copy text: ', err);
	});
	},

	setEventBindings() {
	state.node.addEventListener('click', (e) => {
		e.preventDefault();
		this.handleCopy();
	});
	},

	init() {
	if (!exists(state.node)) return;
	this.setEventBindings();
	},
};

return module.init();
};

export default {
init({ selector, config = {} }) {
	let selected = document.querySelectorAll(selector);
	if (!selected.length) return;
	return [...selected].map((node) => {
	return mixin({ node, config });
	});
},
};
